import gql, { ResponsiveImage, ResponsiveImageFragment } from 'services/graphql';
import { Filter, Locale } from 'services/graphql/types';

export interface SearchBlogPostsResult {
  id: string;
  slug: string;
  title: string;
  titleImage?: ResponsiveImage;
  lead?: string;
  _publishedAt?: string;
  author?: {
    __typename: string;
    id: string;
    title: string;
    image?: ResponsiveImage;
  };
}

interface Response {
  allBlogPosts: SearchBlogPostsResult[];
  _allBlogPostsMeta: { count: number };
}

interface BlogPostModelFilter {
  brand?: Filter<string>;
  _locales?: Filter<string>;
}

export default gql<Response, { first: number; skip: number; locale: Locale; filter: BlogPostModelFilter }>`
  query query($first: IntType, $skip: IntType, $locale: SiteLocale!, $filter: BlogPostModelFilter) {
    allBlogPosts(orderBy: _firstPublishedAt_DESC, first: $first, skip: $skip, filter: $filter, locale: $locale) {
      id
      slug
      title
      _publishedAt: _firstPublishedAt
      titleImage {
        ...ResponsiveImage
      }
      lead
      author {
        title
        image {
          ...ResponsiveImage
        }
      }
    }
    _allBlogPostsMeta(filter: $filter) {
      count
    }
  }
  ${ResponsiveImageFragment}
`;
